import {getWarehouse, getPageWarehouse} from '../../api/endpoints/warehouse'

export const state = {
  currentPage: 1,
  rows: 1,
  perPage: 1,
  data: [],
}

export const getters = {
  tableData: state => state.data,
  rows: state => state.rows,
  perPage: state => state.perPage,
  currentPage: state => state.currentPage
}

export const mutations = {
  GET_TOTAL_ROWS(state) {
    getWarehouse().then( res => {
      state.rows = res.data.total;
    })
  },
  GET_PER_PAPER(state) {
    getWarehouse().then( res => {
      state.perPage = res.data.per_page
    })
  },
  GET_PAGE(state, id) {
    state.currentPage = id
    getPageWarehouse(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_DATA(state) {
    getPageWarehouse(state.currentPage).then( res => {
      state.data = res.data.data
    })
  }
}

export const actions = {
  getRows({commit}) {
    commit('GET_TOTAL_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAPER')
  },
  getPage({commit}, params) {
    commit('GET_PAGE', params)
  },
  getData({commit}, params) {
    commit('GET_DATA', params)
  }
}